"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelAlign = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var b2c_theme_1 = require("../../Theme/b2c-theme");
var Typography_1 = __importStar(require("../../Typography/Typography"));
var LabelAlign;
(function (LabelAlign) {
    LabelAlign["bottom"] = "bottom";
    LabelAlign["top"] = "top";
})(LabelAlign = exports.LabelAlign || (exports.LabelAlign = {}));
var TooltipLabelElement = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  text-align: center;\n  font-family: '", "';\n  background-color: ", ";\n  padding: 0.6rem 1.2rem 0.3rem;\n  width: 100%;\n  position: relative;\n  margin-top: 10px;\n\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: calc(50% - 5px);\n    ", ";\n    width: 0;\n    height: 0;\n    border: 10px solid transparent;\n    ", ";\n  }\n"], ["\n  display: inline-block;\n  text-align: center;\n  font-family: '", "';\n  background-color: ", ";\n  padding: 0.6rem 1.2rem 0.3rem;\n  width: 100%;\n  position: relative;\n  margin-top: 10px;\n\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: calc(50% - 5px);\n    ", ";\n    width: 0;\n    height: 0;\n    border: 10px solid transparent;\n    ", ";\n  }\n"])), function () { return b2c_theme_1.fonts.default; }, function (_a) {
    var labelTheme = _a.labelTheme;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), b2c_theme_1.brandColors[labelTheme]);
}, function (_a) {
    var align = _a.align;
    return (align === LabelAlign.top ? 'bottom: 100%' : 'top: 100%');
}, function (_a) {
    var align = _a.align, labelTheme = _a.labelTheme;
    return align === LabelAlign.top
        ? "border-bottom-color: ".concat(b2c_theme_1.brandColors[labelTheme])
        : "border-top-color: ".concat(b2c_theme_1.brandColors[labelTheme]);
});
var TooltipLabel = function (props) {
    var defaultProps = {
        align: LabelAlign.top,
        theme: b2c_theme_1.BrandColorThemes.serene,
    };
    var _a = __assign(__assign({}, defaultProps), props), align = _a.align, className = _a.className, children = _a.children, theme = _a.theme, rest = __rest(_a, ["align", "className", "children", "theme"]);
    return (react_1.default.createElement(TooltipLabelElement, __assign({ align: align, className: className, "data-testid": "tooltip-label-container", labelTheme: theme }, rest),
        react_1.default.createElement(Typography_1.default, { variant: Typography_1.TypeVariants.span, theme: "white" }, children)));
};
exports.default = TooltipLabel;
var templateObject_1, templateObject_2;
//# sourceMappingURL=TooltipLabel.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Labels/TooltipLabel/TooltipLabel.js
// module id = 1499
// module chunks = 5 15 16 17 20